import { render, staticRenderFns } from "./PdpFooter.vue?vue&type=template&id=6daa0615&scoped=true"
import script from "./PdpFooter.vue?vue&type=script&lang=js"
export * from "./PdpFooter.vue?vue&type=script&lang=js"
import style0 from "./PdpFooter.vue?vue&type=style&index=0&id=6daa0615&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6daa0615",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F03-organisms%2Fproduct-details-26%2Fsubcomponents%2Fpdp-footer%2FPdpFooter.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports